
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service",
      function () {
        return require("private-next-pages/service.tsx");
      }
    ]);
  